// extracted by mini-css-extract-plugin
export default {"container":"preLoader_container__0h6s2","loader":"preLoader_loader__ls2XP","l3":"preLoader_l3__qbsM2"};